import classNames from 'classnames';
import { FC, ReactElement, useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactSignatureCanvasModule from 'react-signature-canvas';

import IconButton from '../../../../components/IconButton/IconButton';
import { SignatureImageUploadBody } from '../../../../interfaces/Signature';
import styles from './SignatureCanvas.module.scss';

type ReactSignatureCanvas = ReactSignatureCanvasModule;

// react-signature-canvas is a UMD/CJS bundle with `exports.default`; Vite 8 does not unwrap it for default imports
const ReactSignatureCanvas = (
  (ReactSignatureCanvasModule as unknown as { default?: typeof ReactSignatureCanvasModule }).default ?? ReactSignatureCanvasModule
);

interface SignatureCanvasProps {
  disabled?: boolean;
  onClear: () => void;
  onDraw: (image: SignatureImageUploadBody['file'] | null) => void;
}

const SignatureCanvas: FC<SignatureCanvasProps> = ({ onDraw, onClear, disabled }): ReactElement | null => {
  const { t } = useTranslation();
  const [isCanvasActive, setIsCanvasActive] = useState<boolean>(false);
  const canvasRef = useRef<ReactSignatureCanvas | null>(null);
  const containerStyle = classNames(styles.canvasContainer, (isCanvasActive && !disabled) && ['partner-border-font-color']);

  const handleOnDrawBegin = useCallback(() => {
    if (canvasRef.current) {
      canvasRef.current.getCanvas().toBlob(onDraw, 'image/png');
    }
  }, [onDraw]);

  const onClearHanler = useCallback(() => {
    if (canvasRef.current) {
      canvasRef.current.clear();
      onClear();
    }
  }, [onClear]);

  return (
    <div className={containerStyle}>
      {(!isCanvasActive || disabled) ? (
        <button className={styles.canvasOverlayButton} onClick={() => setIsCanvasActive(true)}>
          {t('signature:activateSignature')}
        </button>
      ) : (
        <>
          <ReactSignatureCanvas
            canvasProps={{
              style: {
                width: '100%',
              }
            }}
            clearOnResize={false}
            onEnd={handleOnDrawBegin}
            ref={canvasRef}
            throttle={0}
          />
          <IconButton
            className={styles.undoButton}
            icon="undo"
            onClick={onClearHanler}
          />
        </>
      )}
    </div>
  );
};

export default SignatureCanvas;
